function i(r, d) {
  return {
    added: d.filter((e) => !r.includes(e)),
    removed: r.filter((e) => !d.includes(e))
  };
}
export {
  i as getArrayDifference
};
